/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Rows an undo brought back; the page adds them to the grid.
 */
export type RestoredMapping = {
  readonly id?: number;
  source_type: RestoredMapping.source_type;
  document_reference: number;
  field_name?: string | null;
  sheet_name: string;
  cell_references?: any;
  /**
   * Null for callers who do not review AI work.
   */
  status?: RestoredMapping.status | null;
  /**
   * Null for callers who do not review AI work.
   */
  review_reason?: string | null;
  /**
   * Null for callers who do not review AI work.
   */
  created_source?: RestoredMapping.created_source | null;
  readonly created_by?: string;
  readonly created_at?: string;
  readonly updated_at?: string;
  security_id: number;
};
export namespace RestoredMapping {
  export enum source_type {
    CITATION = 'citation',
    MAPPING = 'mapping',
  }
  /**
   * Null for callers who do not review AI work.
   */
  export enum status {
    PENDING = 'pending',
    ACCEPTED = 'accepted',
    DISMISSED = 'dismissed',
  }
  /**
   * Null for callers who do not review AI work.
   */
  export enum created_source {
    AI = 'ai',
    HUMAN = 'human',
  }
}

